import React, { Fragment } from 'react';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { getAppUrl } from 'app/developer-v3/utils';

import TodoItem from './TodoItem';

type Props = {
  integrationId: number;
  integrationName: string;
};

export default function TodosPartnership({
  integrationId,
  integrationName,
}: Props) {
  return (
    <Fragment>
      <TodoItem
        description={
          <Fragment>
            Zap templates are pre-built workflows that simplify automation for
            your existing and prospective users. These workflows connect your
            app with other popular apps to help users start automating tasks
            right away.{' '}
            <Link
              href={`${ZAPIER_APP_BASE_URL}/app/editor/zap-template`}
              target="_blank"
            >
              Create at least 10 templates
            </Link>{' '}
            to inspire users and showcase your app's capabilities.
          </Fragment>
        }
        icon="miscBoltFill"
        title="Optimize your integration's SEO by creating Zap Templates"
      />
      <TodoItem
        description={
          <Fragment>
            Most partners who embed Zapier see a 29-65% user increase in
            integration usage along with higher retention, more customer
            upgrades, and improved lifetime value from their users. Embedding
            makes it easy for your customers to discover and set up automated
            workflows with your app. Get started by{' '}
            <Link href={`${getAppUrl(integrationId)}/embed`}>
              exploring all your embedding options
            </Link>
            .
          </Fragment>
        }
        icon="personGroupFill"
        title="Get more users by embedding Zapier"
      />
      <TodoItem
        description={
          <Fragment>
            Create and publish help docs for using the {integrationName}{' '}
            integration on your own website.{' '}
            <Link
              href={`${BASE_DOC_URL_VB}/publish/user-help#create-help-documentation-for-your-users`}
              target="_blank"
            >
              Learn more about writing help content for your integration
            </Link>
            .
          </Fragment>
        }
        icon="navHelpFill"
        title="Publish help content"
      />
      <TodoItem
        description={
          <Fragment>
            Feedback is crucial to keep your integration healthy. That's why
            it's important to stay on top of user feedback and Zapier's
            recommendations. Our{' '}
            <Link
              href={`${BASE_DOC_URL_VB}/publish/partner-program#integration-health-score`}
              target="_blank"
            >
              custom health score
            </Link>{' '}
            helps you understand how your app is performing. After all, a
            healthy app means more partner benefits and higher usage!
          </Fragment>
        }
        icon="commentConvoFill"
        title="Act on feedback"
      />
    </Fragment>
  );
}
